<template>
    <div>
        <br>
        <h3>Mutasi Objek Pajak/Wajib Pajak</h3>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Cetak Salinan Atas</span>
            </div>
            <div class="col-sm-3">
                <select class="form-control">
                    <option>0 - SPPT</option>
                    <option>1 - SKP Terhadap SPOP</option>
                    <option>2 - SKP Kurang Bayar</option>
                </select>
            </div>
            <div class="col-sm-7"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>No Pelayanan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-7"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Cetak Salinan Atas</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="74" disabled>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="05" disabled>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-3"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Nama Wajib Pajak</span>
            </div>
            <div class="col-sm-5">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-5"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Alamat Wajib Pajak</span>
            </div>
            <div class="col-sm-5">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-5"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tahun Pajak</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-9"></div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tanggal Jatuh Tempo</span>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tempat Pembayaran</span>
            </div>
            <div class="col-sm-3">
                <select class="form-control">
                    <option>0 - BANK SULTRA</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tanggal Cetak</span>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control">
            </div>
        </div>
        <br> <hr>
        <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-10">
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons"></i>Proses</button>
                &nbsp;
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons"></i>Batal</button>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
